import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import App from './App.jsx'
import GlobalErrorBoundary from '@/components/error/GlobalErrorBoundary'
import posthogAnalytics from '@/lib/posthog'
import { ensureCdVid } from '@/lib/funnel'

import '@/styles/globals.css'

// Initialize PostHog
posthogAnalytics.init()

// Journeys: first-party anonymous visitor id (cd_vid cookie). Additive; never throws.
try {
  ensureCdVid()
} catch (_) {
  /* analytics must never break boot */
}

// Install global fetch tracker (must be after PostHog init)
import '@/lib/fetch-tracker'

// Direct API hosts fall back to their Cloudflare twins when a network blocks them.
// After the tracker, so the tracker still sees the first failed attempt.
import '@/lib/originFallback'

// Re-creates the shared login cookies the builder reads when they have expired.
import '@/lib/sharedAuthCookie'

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 10, // 10 minutes
      retry: (failureCount, error) => {
        // Don't retry on 401/403 errors
        if (error?.status === 401 || error?.status === 403) {
          return false
        }
        return failureCount < 3
      },
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <App />
          <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
      </BrowserRouter>
    </GlobalErrorBoundary>
  </React.StrictMode>
)

